// @ts-nocheck
// @ts-ignore
/**
 * ============================================
 * UPSELL PDP POPUP
 * ============================================
 *
 * Shows a "Complete Your Swim Ensemble" popup after
 * a product is added to cart or updated in cart on the PDP.
 *
 * Product data comes from window.__upsellingPdpProducts
 * (injected by Liquid from custom.upselling_pdp_products metafield).
 *
 * Product cards use the neo-product-card-1 design (same as
 * recently-viewed-products and similar-products).
 *
 * Depends on globals from custom-product-atc.js:
 *   - addVariantToCart()
 *   - dispatchCartUpdateEvent()
 *   - cartArray (writable)
 *
 * VARIANT SELECTION:
 *   - Single variant product  → shows variant name as static label (no modal)
 *   - Multi variant product   → shows "Select Size" button → opens inline
 *                               size-picker modal → then adds selected variant
 */

// ─── DOM / CSS / HTML Injection ──────────────────────────────────────────────

/**
 * Creates and injects the upsell popup CSS + HTML into the DOM (once).
 */
function ensureUpsellPopupExists() {
    if (document.getElementById('upsell-pdp-popup')) {
        return;
    }

    // ── Inject CSS ──
    const style = document.createElement('style');
    style.textContent = `
        /* ── Overlay ── */
        .upsell-pdp-overlay {
            position: fixed;
            inset: 0;
            background: rgba(0,0,0,0.5);
            z-index: 9998;
            opacity: 0;
            visibility: hidden;
            transition: opacity 0.3s ease, visibility 0.3s ease;
        }
        .upsell-pdp-overlay.active {
            opacity: 1;
            visibility: visible;
        }

        /* ── Popup container ── */
        .upsell-pdp-popup {
            position: fixed;
            z-index: 9999;
            background: #fff;
            overflow: hidden;
            transition: transform 0.35s cubic-bezier(.4,0,.2,1), opacity 0.3s ease;
        }

        /* Desktop: centered modal */
        @media (min-width: 751px) {
            .upsell-pdp-popup {
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) scale(0.92);
                opacity: 0;
                visibility: hidden;
                width: 620px;
                max-width: 90vw;
                max-height: 90vh;
                border-radius: 6px;
                box-shadow: 0 8px 32px rgba(0,0,0,0.18);
                overflow: hidden;
            }
            .upsell-pdp-popup.active {
                transform: translate(-50%, -50%) scale(1);
                opacity: 1;
                visibility: visible;
            }
        }

        /* Mobile: bottom sheet */
        @media (max-width: 750px) {
            .upsell-pdp-popup {
                bottom: 0;
                left: 0;
                right: 0;
                transform: translateY(100%);
                border-radius: 6px 6px 0 0;
                max-height: 85vh;
                overflow: hidden;
                box-shadow: 0 -4px 24px rgba(0,0,0,0.15);
            }
            .upsell-pdp-popup.active {
                transform: translateY(0);
            }
        }

        /* ── Popup Header ── */
        .upsell-pdp-popup__header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding: 16px 16px 0;
        }

        .upsell-pdp-popup__title {
            font-family: 'Athletics-Bold', sans-serif;
            font-size: 18px;
            line-height: 1.25;
            color: #000;
            margin: 0;
        }

        .upsell-pdp-popup__subtitle {
            font-family: 'Athletics-Regular', sans-serif;
            font-size: 12px;
            color: #666;
            margin-bottom: 10px;
            margin-top: 0;
            line-height: 1.3;
            padding: 0 16px;
        }

        .upsell-pdp-popup__close {
            background: none;
            border: 1.5px solid #000;
            border-radius: 50%;
            cursor: pointer;
            width: 32px;
            height: 32px;
            padding: 0;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 12px;
        }
        .upsell-pdp-popup__close svg {
            width: 13px;
            height: 13px;
        }

        @media (max-width: 750px) {
            .upsell-pdp-popup__close {
                position: absolute;
                top: 10px;
                right: 12px;
                z-index: 10;
                margin-left: 0;
            }
        }

        /* ── Mobile drag handle ── */
        .upsell-pdp-popup__drag-handle {
            display: none;
        }
        @media (max-width: 750px) {
            .upsell-pdp-popup__drag-handle {
                display: block;
                width: 48px;
                height: 5px;
                background: #ccc;
                border-radius: 3px;
                margin: 10px auto 0;
            }
        }

        /* ── Swiper container ── */
        .upsell-pdp-swiper {
            padding: 12px 16px 10px !important;
            overflow: hidden;
        }
        .upsell-pdp-swiper .swiper-slide {
            height: auto;
            display: flex;
        }

        /* ── Swiper pagination ── */
        .upsell-pdp-swiper .swiper-pagination {
            position: relative;
            bottom: auto;
            margin-top: 20px;
            margin-bottom: 10px;
            display: flex;
            justify-content: center;
            gap: 2px;
        }
        .upsell-pdp-swiper .swiper-pagination-bullet {
            width: 6px;
            height: 6px;
            border-radius: 0;
            background: #ffffff;
            border: 1px solid #000000;
            opacity: 1;
            transition: background 0.2s;
        }
        .upsell-pdp-swiper .swiper-pagination-bullet-active {
            background: #333;
        }

        /* ── Neo Product Card scoped styles for upsell popup ── */
        .upsell-pdp-popup .neo-product-card-1 {
            height: 100%;
            gap: 2px;
            width: 100%;
        }

        .upsell-pdp-popup .neo-product-card-details {
            padding: 10px 10px 0;
            gap: 6px;
        }

        .upsell-pdp-popup .title-container {
            gap: 4px;
        }

        .upsell-pdp-popup .neo-product-card-title {
            font-size: 13px;
            line-height: 1.2;
        }

        .upsell-pdp-popup .neo-product-card-title.min-height,
        .upsell-pdp-popup .neo-product-card-sub-title.min-height {
            min-height: unset;
        }

        .upsell-pdp-popup .neo-product-card-sub-title {
            font-size: 11px;
            line-height: 1.2;
        }

        .upsell-pdp-popup .neo-product-card-wishlist .smartwishlist {
            width: 30px;
            height: 30px;
            padding: 8px;
        }

        .upsell-pdp-popup .neo-product-card-media-container {
            flex: 1 1 0%;
            min-height: 0;
        }

        .upsell-pdp-popup .neo-product-card-media {
            aspect-ratio: 1 / 1;
            height: 100%;
        }

        .upsell-pdp-popup .neo-product-card-1__image-img {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: block;
            object-fit: contain;
            object-position: bottom;
        }

        .upsell-pdp-popup .neo-product-card-1-tag {
            bottom: 112px; /* clear the pill (68px) + a little breathing room */
        }

        .upsell-pdp-popup .neo-product-card-1__footer {
            position: absolute;
            bottom: 10px;
            left: 10px;
            right: 10px;
            background: #000000;
            min-height: 48px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 8px;
            overflow: visible;
            cursor: pointer;
            z-index: 2;
            transition: background 0.2s ease;
        }

        .upsell-footer__corner {
            position: absolute;
            width: 8px;
            height: 8px;
            pointer-events: none;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .upsell-footer__corner--tl {
            top: 5px;
            left: 7px;
        }
        .upsell-footer__corner--tr {
            top: 5px;
            right: 7px;
            transform: rotate(90deg);
        }
        .upsell-footer__corner--bl {
            bottom: 5px;
            left: 7px;
            transform: rotate(-90deg);
        }
        .upsell-footer__corner--br {
            bottom: 5px;
            right: 7px;
            transform: rotate(180deg);
        }

        .upsell-pdp-popup .neo-product-card-1__footer-content {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 12px;
            width: 100%;
            padding: 0 12px;
        }

        .upsell-pdp-popup .neo-product-card-1__price {
            font-family: "Athletics-Regular", sans-serif;
            font-size: 14px;
            line-height: 92%;
            letter-spacing: -0.01em;
            color: #ffffff;
        }

        .upsell-pdp-popup .neo-product-card-1__separator {
            width: 1px;
            height: 14px;
            background: #ffffff;
            opacity: 0.3;
            flex-shrink: 0;
        }

        .upsell-pdp-popup .neo-product-card-1__add-btn {
            font-family: "Athletics-Regular", sans-serif;
            background: transparent;
            border: none;
            color: #ffffff;
            font-size: 14px;
            line-height: 92%;
            letter-spacing: -0.01em;
            cursor: pointer;
            padding: 0;
            display: inline-flex;
            align-items: center;
            gap: 4px;
        }

        .upsell-pdp-popup .neo-product-card-1__add-btn .add-to-cart-button-gql-bag {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 15px;
            height: 15px;
            flex-shrink: 0;
        }

        .upsell-pdp-popup .neo-product-card-1__add-btn .add-to-cart-button-gql-bag svg {
            width: 15px;
            height: 15px;
            display: block;
        }

        .upsell-pdp-popup .neo-product-card-1__add-btn:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }

        /* ── Single variant label (static, no interaction) ── */
        .upsell-pdp-popup .neo-product-card-1__single-variant-label {
            font-family: "Athletics-Regular", sans-serif;
            font-size: 13px;
            line-height: 92%;
            letter-spacing: -0.01em;
            color: rgba(255, 255, 255, 0.75);
        }

        /* ── SELECT SIZE pill — floats over the image, just above the black footer ── */
        .upsell-select-size-pill {
            position: absolute;
            bottom: 68px; /* sits just above the 48px footer + 10px gap */
            left: 10px;
            z-index: 4;
            display: inline-flex;
            align-items: center;
            gap: 6px;
            background: #ffffff7a;;
            border: 1.5px solid #e0e0e0;
            border-radius: 20px;
            padding: 5px 5px 5px 7px;
            cursor: pointer;
            font-family: 'Athletics-Regular', sans-serif;
            font-size: 8px;
            letter-spacing: 0.04em;
            text-transform: uppercase;
            color: #000;
            white-space: nowrap;
            box-shadow: 0 2px 8px rgba(0,0,0,0.10);
            transition: border-color 0.15s;
            user-select: none;
        }
        .upsell-select-size-pill span {
            font-size: 9px;
            color: black;
            text-transform: uppercase;
            font-family: Athletics-Medium,sans-serif;
        }
        .upsell-select-size-pill svg {
            transition: transform 0.2s ease;
            flex-shrink: 0;
        }
        .upsell-select-size-pill.open {
            border-color: #000;
        }
        .upsell-select-size-pill.open svg {
            transform: rotate(180deg);
        }
        /* Static pill for single-variant products — no interaction */
        .upsell-select-size-pill--static {
            cursor: default;
            pointer-events: none;
            padding-right: 14px; /* same both sides, no chevron */
        }
        .upsell-select-size-pill--static:hover {
            border-color: #e0e0e0;
        }

        /* ── Size picker panel — grows upward from the pill ── */
        .upsell-size-picker {
            position: absolute;
            left: 10px;
            right: 10px;
            bottom: 95px;
            background: rgba(255, 255, 255, 0.97);
            border-radius: 10px;
            padding: 10px 10px 8px;
            z-index: 4;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.13);
            transform-origin: bottom center;
            transform: scaleY(0) translateY(8px);
            opacity: 0;
            pointer-events: none;
            transition: transform 0.22s cubic-bezier(.4, 0, .2, 1), opacity 0.18s ease;
        }
        .upsell-size-picker.open {
            transform: scaleY(1) translateY(0);
            opacity: 1;
            pointer-events: auto;
            max-height: 80px;
            overflow-y: scroll;
        }
        .upsell-size-picker.open::-webkit-scrollbar-thumb {
            background-color: transparent;
            display: none;
        }
        .upsell-size-picker.open::-webkit-scrollbar-button {
            display: none !important;
            width: 0 !important;
            height: 0 !important;
        }

        .upsell-size-picker__grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 6px;
        }

        .upsell-size-picker__size-btn {
            font-family: 'Athletics-Regular', sans-serif;
            font-size: 9px;
            border: 1.5px solid #e0e0e0;
            border-radius: 8px;
            background: #fff;
            color: #000;
            padding: 9px 4px;
            cursor: pointer;
            text-align: center;
            transition: border-color 0.15s, background 0.15s, color 0.15s;
            line-height: 1;
        }
        .upsell-size-picker__size-btn:hover {
            border-color: #000;
        }
        .upsell-size-picker__size-btn.selected {
            background: #000;
            color: #fff;
            border-color: #000;
        }
        .upsell-size-picker__size-btn:disabled {
            opacity: 0.35;
            cursor: not-allowed;
            text-decoration: line-through;
        }

        /* Body scroll lock when popup is open */
        body.upsell-popup-open {
            overflow: hidden;
        }
    `;
    document.head.appendChild(style);

    // ── Inject HTML ──
    const overlay = document.createElement('div');
    overlay.className = 'upsell-pdp-overlay';
    overlay.id = 'upsell-pdp-overlay';

    const popup = document.createElement('div');
    popup.className = 'upsell-pdp-popup';
    popup.id = 'upsell-pdp-popup';
    popup.innerHTML = `
        <div class="upsell-pdp-popup__drag-handle" id="upsellPdpPopupGesture" aria-hidden="true"></div>
        <div class="upsell-pdp-popup__header">
            <h2 class="upsell-pdp-popup__title">Complete Your Swim Essentials</h2>
            <button type="button" class="upsell-pdp-popup__close" id="upsellPdpPopupClose" aria-label="Close">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
                    <path d="M10 1L1 10" stroke="black" stroke-width="1.5"/>
                    <path d="M1 1L10 10" stroke="black" stroke-width="1.5"/>
                </svg>
            </button>
        </div>
        <p class="upsell-pdp-popup__subtitle">Pair your product with these essentials for optimal comfort and performance</p>
        <div class="swiper upsell-pdp-swiper" id="upsell-pdp-swiper">
            <div class="swiper-wrapper" id="upsell-pdp-swiper-wrapper"></div>
            <div class="swiper-pagination"></div>
        </div>
    `;

    document.body.appendChild(overlay);
    document.body.appendChild(popup);

    // ── Close handlers ──
    overlay.addEventListener('click', closeUpsellPopup);
    popup.querySelector('.upsell-pdp-popup__close').addEventListener('click', closeUpsellPopup);

    // Mobile drag-to-dismiss (bottom sheet; matches add-to-card-modal setupGestureHandler)
    if (typeof window.setupGestureHandler === 'function') {
        window.setupGestureHandler({
            gestureElementId: 'upsellPdpPopupGesture',
            modalContent: popup,
            closeBtnId: 'upsellPdpPopupClose',
            onClose: closeUpsellPopup,
            mobileMaxWidth: 750,
        });
    }
}

// ─── Helpers ─────────────────────────────────────────────────────────────────

/**
 * Escapes HTML special characters to prevent XSS.
 */
function escapeUpsellHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}

/**
 * Formats price for display (INR).
 */
function getUpsellAtcAddHtml() {
    const bag = (window.AtcPriceBlock && window.AtcPriceBlock.bagHtml) || '';
    return '<span class="upsell-pdp-popup__add-label">+ Add</span>' + bag;
}

function formatUpsellPrice(price) {
    // Strip commas from money_without_currency output (e.g. "1,999.00" → "1999.00")
    const num = parseFloat(String(price).replace(/,/g, ''));
    if (isNaN(num)) return '';
    return '₹' + Math.round(num).toLocaleString('en-IN');
}

/**
 * Returns the variants array for a product.
 * Expects product.variants as an array of { id, title, available } objects.
 * Falls back gracefully if variants is missing.
 */
function getUpsellVariants(product) {
    if (Array.isArray(product.variants) && product.variants.length > 0) {
        return product.variants;
    }
    // Fallback: treat the single variantId on the product as the only variant
    return [{
        id: product.variantId,
        title: product.firstVariantSize || 'One Size',
        available: product.available !== false,
    }];
}

// ─── ATC Helper (shared by single & multi-variant paths) ─────────────────────

/**
 * Performs the add-to-cart action for a given variantId.
 * Returns a promise that resolves when done.
 * @param {number|string} variantId
 * @param {HTMLButtonElement} addBtn  - button to show feedback on
 */
async function upsellAddVariantToCart(variantId, addBtn) {
    const vId = parseInt(variantId, 10);
    if (!vId) return;

    // Guard: if button is in "View Cart" mode, open cart and do nothing else
    if (addBtn.dataset.mode === 'view-cart') {
        closeUpsellPopup();
        document.querySelector('cart-drawer-component')?.open();
        return;
    }

    const originalHtml = addBtn.innerHTML;
    addBtn.textContent = 'Adding...';
    addBtn.disabled = true;

    try {
        globalEnableNudges("add to cart");
        await addVariantToCart(vId, 1);
        const freshCart = await fetch('/cart.js').then(r => r.json());
        window.latestCartData = freshCart;
        cartArray = freshCart.items || [];

        const cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer) {
            cartDrawer.removeAttribute('auto-open');
        }

        const deferSync = !!document.querySelector('cart-items-component');
        if (deferSync && typeof window.requestSyncCartDrawerAfterSectionRender === 'function') {
            window.requestSyncCartDrawerAfterSectionRender();
        }

        dispatchCartUpdateEvent(freshCart);

        if (!deferSync && typeof window.syncCartDrwer === 'function') {
            window.syncCartDrwer();
        }

        addBtn.textContent = 'View Cart';
        addBtn.dataset.mode = 'view-cart'; // set flag before re-enabling
        addBtn.disabled = false;

    } catch (err) {
        console.error('Upsell ATC error:', err);
        addBtn.innerHTML = originalHtml;
        addBtn.disabled = false;
    } finally {
        globalDisableNudges();
    }
}

// ─── Size Picker (pill + grid floating over card image) ──────────────────────

/**
 * Builds the SELECT SIZE pill and the size-grid panel that pops above it.
 * Both float over the product image; the black ATC footer is untouched.
 *
 * @param {object}      product        - product data
 * @param {HTMLElement} mediaContainer - .neo-product-card-media element
 * @param {HTMLElement} addBtn         - "Add to Cart" btn in the black footer (ATC feedback)
 */
function buildSizePicker(product, mediaContainer, addBtn) {
    const variants = getUpsellVariants(product);

    // Tracks the currently selected variant; null = none selected yet
    let selectedVariantId = null;

    const chevronSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
        <path d="M9 1L5 5L1 1" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

    // ── Pill (SELECT SIZE ▼  →  Size - 32 ▼ after selection) ──
    const pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'upsell-select-size-pill';
    pill.setAttribute('aria-label', 'Select size');
    pill.innerHTML = `<span class="upsell-pill__text">SELECT SIZE</span>${chevronSVG}`;
    mediaContainer.appendChild(pill);

    const pillText = pill.querySelector('.upsell-pill__text');

    // ── Size grid panel (above the pill) ──
    const picker = document.createElement('div');
    picker.className = 'upsell-size-picker';

    const grid = document.createElement('div');
    grid.className = 'upsell-size-picker__grid';

    variants.forEach(variant => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'upsell-size-picker__size-btn';
        btn.textContent = variant.title;
        btn.dataset.variantId = variant.id;
        if (!variant.available) {
            btn.disabled = true;
        }

        btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!variant.available) return;

            // Mark selected in grid
            grid.querySelectorAll('.upsell-size-picker__size-btn').forEach(b => b.classList.remove('selected'));
            btn.classList.add('selected');

            // Store selection and update pill text — do NOT add to cart yet
            selectedVariantId = variant.id;
            pillText.textContent = `Size - ${variant.title}`;

            // Enable the footer ATC button now that a size is chosen
            addBtn.disabled = false;
            addBtn.dataset.variantId = variant.id;

            closePicker();
        });

        grid.appendChild(btn);
    });

    picker.appendChild(grid);
    mediaContainer.appendChild(picker);

    // ── Wire footer ATC button for multi-variant ──
    // (addBtn starts disabled; enabled only after a size is picked above)
    addBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!selectedVariantId || addBtn.disabled) return;
        await upsellAddVariantToCart(selectedVariantId, addBtn);
    });

    // ── Toggle open / close ──
    function openPicker() {
        picker.classList.add('open');
        pill.classList.add('open');
    }

    function closePicker() {
        picker.classList.remove('open');
        pill.classList.remove('open');
    }

    pill.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        picker.classList.contains('open') ? closePicker() : openPicker();
    });

    // Close when clicking outside both the picker panel and the pill
    document.addEventListener('click', (e) => {
        if (picker.classList.contains('open') && !picker.contains(e.target) && !pill.contains(e.target)) {
            closePicker();
        }
    }, { capture: true });

    return { openPicker, closePicker };
}

// ─── Card Builder (neo-product-card-1) ───────────────────────────────────────

/**
 * Creates a neo-product-card-1 element for the upsell popup.
 *
 * Footer behaviour:
 *   - Single variant  → shows static variant name label + "Add to Cart" button
 *   - Multi variant   → shows "SELECT SIZE ▲" button; clicking opens inline size picker
 */
function createUpsellCard(product) {
    const card = document.createElement('div');
    card.className = 'neo-product-card-1';

    const titleSafe = escapeUpsellHtml(product.title);
    const highlightsText = Array.isArray(product.highlights)
        ? escapeUpsellHtml(product.highlights.join(' | '))
        : (product.highlights ? escapeUpsellHtml(product.highlights) : '');
    const tagHTML = product.tag ? `<p class="neo-product-card-1-tag">${escapeUpsellHtml(product.tag)}</p>` : '';

    const variants = getUpsellVariants(product);
    const isMultiVariant = variants.length > 1;

    // ── Footer HTML ──
    // Both single and multi-variant footers show only price + Add to Cart.
    // Single: ATC enabled immediately (one variant, no choice needed).
    // Multi:  ATC starts disabled until a size is selected via the pill.
    const footerActionHTML = `
        <button class="neo-product-card-1__add-btn" type="button"
            data-variant-id="${isMultiVariant ? '' : variants[0].id}"
            ${(isMultiVariant || !variants[0].available) ? 'disabled' : ''}>
            ${!variants[0].available ? 'Sold Out' : getUpsellAtcAddHtml()}
        </button>`;

    const cornerSVG = (id) => `
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
            <mask id="upsell-cm-${id}" fill="white">
                <path d="M0 2C0 0.895431 0.895431 0 2 0H6C7.10457 0 8 0.895431 8 2V6C8 7.10457 7.10457 8 6 8H2C0.895431 8 0 7.10457 0 6V2Z"/>
            </mask>
            <path d="M-0.5 2C-0.5 0.619288 0.619288 -0.5 2 -0.5H5.5C6.88071 -0.5 8 0.619288 8 2C8 1.17157 7.10457 0.5 6 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2H-0.5ZM8 8H0H8ZM2 8C0.619288 8 -0.5 6.88071 -0.5 5.5V2C-0.5 0.619288 0.619288 -0.5 2 -0.5V0.5C1.17157 0.5 0.5 1.17157 0.5 2V6C0.5 7.10457 1.17157 8 2 8ZM8 0V8V0Z" fill="#ffffff" mask="url(#upsell-cm-${id})"/>
        </svg>`;

    card.innerHTML = `
        <div class="neo-product-card-details">
            <a class="title-container" href="/products/${product.handle}">
                <h2 class="visually-hidden">${titleSafe}</h2>
                <p class="neo-product-card-title line-clamp-2 min-height">${titleSafe}</p>
                <p class="neo-product-card-sub-title line-clamp-2 min-height">${highlightsText}</p>
            </a>
            <div class="neo-product-card-wishlist">
                <span
                    class="smartwishlist"
                    data-product="${product.productId}"
                    data-variant="${product.variantId}"
                ></span>
            </div>
        </div>
        <div class="neo-product-card-media-container">
            <div class="neo-product-card-media">
                <img class="neo-product-card-1__image-img" src="${escapeUpsellHtml(product.image)}&width=520" alt="${titleSafe}" width="500">
                ${tagHTML}
                <div class="neo-product-card-1__footer">
                    <span class="upsell-footer__corner upsell-footer__corner--tl">${cornerSVG('tl-' + product.variantId)}</span>
                    <span class="upsell-footer__corner upsell-footer__corner--tr">${cornerSVG('tr-' + product.variantId)}</span>
                    <span class="upsell-footer__corner upsell-footer__corner--bl">${cornerSVG('bl-' + product.variantId)}</span>
                    <span class="upsell-footer__corner upsell-footer__corner--br">${cornerSVG('br-' + product.variantId)}</span>
                    <div class="neo-product-card-1__footer-content">
                        <span class="neo-product-card-1__price">${formatUpsellPrice(product.price)}</span>
                        <span class="neo-product-card-1__separator"></span>
                        ${footerActionHTML}
                    </div>
                </div>
            </div>
        </div>
    `;

    const footer = card.querySelector('.neo-product-card-1__footer');
    const mediaContainer = card.querySelector('.neo-product-card-media');
    const addBtn = card.querySelector('.neo-product-card-1__add-btn');

    if (isMultiVariant) {
        // Pill + size picker float over image; ATC is wired inside buildSizePicker
        buildSizePicker(product, mediaContainer, addBtn);
    } else {
        // ── Single-variant: static "Size - X" pill over image (non-interactive) ──
        const staticPill = document.createElement('span');
        staticPill.className = 'upsell-select-size-pill upsell-select-size-pill--static';
        staticPill.textContent = `Size - ${variants[0].title}`;
        mediaContainer.appendChild(staticPill);

        // Footer ATC wired directly
        if (footer && addBtn && variants[0].available) {
            footer.addEventListener('click', async function (e) {
                e.preventDefault();
                e.stopPropagation();
                await upsellAddVariantToCart(variants[0].id, addBtn);
            });
        }
    }

    // ── Wishlist ──
    const el = card.querySelector('.smartwishlist');
    el.addEventListener('click', (event) => {
        handleWishlistStateAndUpdateCart(event, {
            title: `${product.title ?? null}`,
            handle: `${product.handle ?? null}`,
            vendor: null,
            variant_id: `${product.variantId ?? null}`,
            is_true_variant: null,
            variant_count: `${product?.options?.[0]?.values?.length ?? null}`,
            variant_title: `${product?.firstVariantSize ?? null}`,
            variant_price: `${product?.price ? parseFloat(product.price.replace(/,/g, '')) : null}`,
            variant_compare_at_price: `${product?.compareAtPrice ? parseFloat(product.compareAtPrice.replace(/,/g, '')) : null}`,
            variant_sku: null,
            variant_out_of_stock: `${product.available === false}`,
            variant_inventory_policy: null,
            variant_inventory_quantity: null,
            tags: `${product.tags ?? null}`,
            image: `${product.image ?? null}`
        });
    });

    return card;
}

// ─── Cart Drawer Auto-Open Restore ──────────────────────────────────────────

/**
 * Restores the 'auto-open' attribute on the cart drawer component.
 * Called when the upsell popup closes or when popup open is aborted.
 */
function restoreCartDrawerAutoOpen() {
    const cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer && !cartDrawer.hasAttribute('auto-open')) {
        cartDrawer.setAttribute('auto-open', '');
    }
}

// ─── Swiper Instance ─────────────────────────────────────────────────────────

let upsellSwiperInstance = null;

// ─── Open / Close ────────────────────────────────────────────────────────────

/**
 * Clears inline styles applied during drag so CSS open/close transitions work.
 */
function clearUpsellPopupGestureStyles() {
    const popup = document.getElementById('upsell-pdp-popup');
    if (!popup) return;
    popup.style.animation = '';
    popup.style.transform = '';
    popup.style.transition = '';
}

/**
 * Opens the upsell popup with the provided products data.
 */
function openUpsellPopup(products) {
    if (!products || products.length === 0) {
        restoreCartDrawerAutoOpen();
        return;
    }

    // Filter out sold-out products
    const availableProducts = products.filter(p => p.available);
    if (availableProducts.length === 0) {
        restoreCartDrawerAutoOpen();
        return;
    }

    ensureUpsellPopupExists();

    const wrapper = document.getElementById('upsell-pdp-swiper-wrapper');
    const swiperEl = document.getElementById('upsell-pdp-swiper');
    const popup = document.getElementById('upsell-pdp-popup');
    const overlay = document.getElementById('upsell-pdp-overlay');

    if (!wrapper || !swiperEl || !popup || !overlay) return;

    clearUpsellPopupGestureStyles();

    // Destroy previous Swiper instance if any
    if (upsellSwiperInstance) {
        upsellSwiperInstance.destroy(true, true);
        upsellSwiperInstance = null;
    }

    // Clear previous slides
    wrapper.innerHTML = '';

    // Build Swiper slides (only available products)
    availableProducts.forEach(p => {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';
        slide.appendChild(createUpsellCard(p));
        wrapper.appendChild(slide);
    });

    // Make the popup occupy layout (off-screen / invisible) so Swiper can
    // compute slide dimensions before the user sees anything.
    popup.getBoundingClientRect();

    // Initialize Swiper FIRST while the popup is still hidden
    upsellSwiperInstance = new Swiper(swiperEl, {
        slidesPerView: 1.5,
        spaceBetween: 12,
        pagination: {
            el: swiperEl.querySelector('.swiper-pagination'),
            clickable: true,
        },
        breakpoints: {
            450: {
                slidesPerView: 2,
                spaceBetween: 12,
            },
            751: {
                slidesPerView: 2,
                spaceBetween: 16,
            }
        }
    });

    // Wait one frame so Swiper finishes layout, then reveal the popup smoothly
    requestAnimationFrame(() => {
        overlay.classList.add('active');
        popup.classList.add('active');
        document.body.classList.add('upsell-popup-open');
    });

    // Re-initialize SmartWishlist if available so the wishlist icons work
    if (typeof ReloadSmartWishlist === 'function') {
        setTimeout(ReloadSmartWishlist, 300);
    }
}

/**
 * Closes the upsell popup.
 */
function closeUpsellPopup() {
    const popup = document.getElementById('upsell-pdp-popup');
    const overlay = document.getElementById('upsell-pdp-overlay');
    if (popup) popup.classList.remove('active');
    if (overlay) overlay.classList.remove('active');

    setTimeout(() => {
        // Destroy Swiper instance
        if (upsellSwiperInstance) {
            upsellSwiperInstance.destroy(true, true);
            upsellSwiperInstance = null;
        }
        clearUpsellPopupGestureStyles();
        document.body.classList.remove('upsell-popup-open');
        // Restore cart drawer auto-open attribute (was removed to suppress auto-open during upsell)
        restoreCartDrawerAutoOpen();
    }, 0);
}

// ─── Entry Point (called from custom-product-atc.js) ─────────────────────────

/**
 * Shows the upsell popup after a product has been added/updated in cart.
 * Uses data from window.__upsellingPdpProducts injected by Liquid.
 */
function showUpsellPopupAfterATC() {
    const products = window.__upsellingPdpProducts;
    if (!products || products.length === 0) {
        return;
    }

    // Small delay so the cart drawer animation can start first
    setTimeout(() => {
        openUpsellPopup(products);
    }, 600);
}